import { LoanStatisticsIndividual, LoanStatisticsOverview } from '../../../store/api';
import { shouldShowUsagePercentage } from '../utils/shouldShowUsagePercentage';

export const mapProductTitleWarningSymbol = ({
    previousLoanStatistics,
    currentLoanStatistics
}: {
    previousLoanStatistics?: LoanStatisticsOverview | LoanStatisticsIndividual | null;
    currentLoanStatistics?: LoanStatisticsOverview | LoanStatisticsIndividual | null;
}): undefined | 'red' | 'orange' => {
    let warningColor: 'red' | 'orange' | undefined = undefined;

    if (previousLoanStatistics?.loansLeft === 0) {
        return 'red';
    }
    if (shouldShowUsagePercentage(previousLoanStatistics?.usagePercentage)) {
        warningColor = 'orange';
    }

    if (currentLoanStatistics?.loansLeft === 0) {
        return 'red';
    }
    if (shouldShowUsagePercentage(currentLoanStatistics?.usagePercentage)) {
        warningColor = 'orange';
    }

    return warningColor;
};
